module.exports = __webpack_public_path__ + "static/devils-bargain-78153bd7751e4064720c2edeb3869030.jpg";